import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=6058922a&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=6058922a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6058922a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6058922a')) {
      api.createRecord('6058922a', component.options)
    } else {
      api.reload('6058922a', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=6058922a&scoped=true&", function () {
      api.rerender('6058922a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wPGUbINmw0hH/JS/comp/CookieBox.vue"
export default component.exports